import { Insurance } from "~/services/insurances/types";

export const NIRVANA_STATUS = {
  COVERED: "covered",
  NOT_COVERED: "not_covered",
  INCONCLUSIVE: "inconclusive",
  SKIPPED: "skipped",
} as const;

export type NirvanaStatus =
  (typeof NIRVANA_STATUS)[keyof typeof NIRVANA_STATUS];

/**
 * Result of the Nirvana eligibility check. Mirrors the backend contract in
 * specs/nirvana-integration/design.md (POST /nirvana-check response).
 * `payerName` is present when the plan was identified (covered / not_covered).
 */
export type NirvanaCheckResult = {
  status: NirvanaStatus;
  payerName?: string | null;
  insuranceCacheKey?: string | null;
  effectiveInsurance?: Insurance | null;
};

/**
 * Demographics collected on the demographics screen. PHI: held in memory only,
 * never persisted to storage (see D-011 in requirements.md).
 */
export type PatientDemographics = {
  legalFirstName: string;
  legalLastName: string;
  dob: string;
  sexAtBirth: string;
  zipCode: string;
};
